
import { mapActions } from 'vuex';
import ArrowIcon from '~/components/ui/icons/ArrowIcon.vue';
import ChevronIcon from '~/components/ui/icons/ChevronIcon.vue';
import { PortfolioOrderTypes } from '@/utils/constants/portfolioConstants';

export default {
  name: 'DropDownOrderType',
  components: { ArrowIcon, ChevronIcon },
  props: {
    isPublic: {
      type: Boolean,
      default: true,
    },
    isSell: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showOrderTypesDropdown: false,
      orderTypesDropdown: [],
      selectedOrderType: null,
    };
  },
  computed: {
    orderTypes() {
      return PortfolioOrderTypes;
    },
  },
  watch: {
    isSell() {
      this.buildOrderTypesDropdown();
    },
    isPublic() {
      this.buildOrderTypesDropdown();
    },
  },
  created() {
    this.buildOrderTypesDropdown();

    this.selectedOrderType = this.orderTypesDropdown.find(
      (o) => o.key === this.orderTypes.MARKET_PRICE
    );

    this.$emit('onSelect', this.selectedOrderType.key);
  },
  methods: {
    ...mapActions('modals', ['toggleShowTransactionTypesModal']),
    selectOrderType(type) {
      this.selectedOrderType = type;
      this.$emit('onSelect', this.selectedOrderType.key);
    },
    handleShowTransactionTypesModal() {
      this.$emit('onShowTransactionTypes');
      this.toggleShowTransactionTypesModal(true);
    },
    buildOrderTypesDropdown() {
      const dropdown = [];

      if (!this.isPublic) {
        dropdown.push({
          key: this.orderTypes.PAST_OPERATION,
          title: this.$t('order_past_transaction_title'),
          description: this.$t('order_past_transaction_description'),
        });
      }

      dropdown.push({
        key: this.orderTypes.MARKET_PRICE,
        title: this.$t('order_market_order_title'),
        description: this.isSell
          ? this.$t('order_market_order_sell_description')
          : this.$t('order_market_order_buy_description'),
      });

      dropdown.push({
        key: this.orderTypes.LIMIT_PRICE,
        title: this.$t('order_limited_price_title'),
        description: this.isSell
          ? this.$t('order_limited_order_sell_description')
          : this.$t('order_limited_order_buy_description'),
      });

      this.orderTypesDropdown = dropdown;

      this.selectedOrderType = this.orderTypesDropdown.find(
        (o) => o.key === this.orderTypes.MARKET_PRICE
      );

      this.$emit('onSelect', this.selectedOrderType.key);
    },
    toggleShowOrderTypesDropdown() {
      this.showOrderTypesDropdown = !this.showOrderTypesDropdown;
    },
    closeOrderTypesDropdown() {
      this.showOrderTypesDropdown = false;
    },
  },
};
